import React from 'react';
import Logo from './Logo';

function Footer() {
  return <footer className="footer"><div className="footer-main"><Logo /></div><div className="footer-bottom"><p className="footer-legal">© 2026 CASE MINING CONSULTANTS LTD. All rights reserved. The material on this site may not be reproduced, distributed, transmitted, cached, or otherwise used, except with the prior written permission of CASE MINING CONSULTANTS LTD.</p></div></footer>;
}

export default Footer;
